import { isSection } from '../select/utils.js';
export const getLastItem = (options) => {
    if (options.length === 0) {
        return undefined;
    }
    const lastItem = options[options.length - 1];
    if (isSection(lastItem.value)) {
        const children = [...lastItem.childNodes];
        return children[children.length - 1];
    }
    return lastItem;
};
//# sourceMappingURL=utils.js.map